import { useEffect } from 'react'
import { useDocumentManagerCapability } from '@embedpdf/plugin-document-manager/react'
import { OcrService } from '../../services/ocr/ocr-service'
import { saveDocument, getPreference, setPreference } from '../../services/indexeddb-service'

let didHandle = false

export function LaunchFileHandler() {
  const { provides: docManager } = useDocumentManagerCapability()

  useEffect(() => {
    if (!docManager || didHandle) return
    const launch = (window as any).__opakorLaunchFile__
    if (!launch) return
    didHandle = true
    const { name, buffer } = launch
    delete (window as any).__opakorLaunchFile__

    const task = docManager.openDocumentBuffer({
      name,
      buffer: buffer.slice(0),
      autoActivate: true,
    })
    task.wait(async () => {
      OcrService.setDocumentName(name)
      saveDocument({
        id: name,
        name,
        buffer: buffer.slice(0),
        byteLength: buffer.byteLength,
        currentPage: 0,
        lastOpened: Date.now(),
      }).catch(() => {})
      getPreference<string[]>('open-documents').then(list => {
        setPreference('open-documents', [...(list || []), name])
      }).catch(() => {})
    }, () => {})
  }, [docManager])

  return null
}
